import { render, staticRenderFns } from "./share.vue?vue&type=template&id=6c4ffe27"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"
import style0 from "./share.vue?vue&type=style&index=0&id=6c4ffe27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports